import { InterruptionEmployeeResponseStatus } from '../../../types';
import useInterruptionService from '../../../useInterruptionService';
import {
  RESPONSE_STATUSES_TO_MESSAGE,
  SendInterruptionTeamsMessageResult,
  InterruptionTeamsMessageSkipReason,
} from './types';

const shouldSendInterruptionResponseMessage = (status: InterruptionEmployeeResponseStatus): boolean =>
  RESPONSE_STATUSES_TO_MESSAGE.has(status);

const useInterruptionTeamsMessage = () => {
  const { sendInterruptionTeamsMessage } = useInterruptionService();

  const sendInterruptionTeamsResponseMessage = async (
    interruptionId: string,
    status: InterruptionEmployeeResponseStatus,
  ): Promise<SendInterruptionTeamsMessageResult> => {
    if (!shouldSendInterruptionResponseMessage(status)) {
      return {
        sent: false,
        reason: InterruptionTeamsMessageSkipReason.UnsupportedStatus,
      };
    }

    try {
      const response = await sendInterruptionTeamsMessage(interruptionId);

      if (response.sent) {
        return {
          ...response,
          sent: true,
        };
      }

      return {
        ...response,
        sent: false,
        reason: response.skipReason ?? InterruptionTeamsMessageSkipReason.BackendSkipped,
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Failed to send interruption teams response message', error);
      return {
        sent: false,
        reason: InterruptionTeamsMessageSkipReason.BackendSkipped,
      };
    }
  };

  return {
    sendInterruptionTeamsResponseMessage,
  };
};

export default useInterruptionTeamsMessage;
